export default __webpack_public_path__ + "static/media/denim.9ed756bd.webp";